// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"0":"draw","177":"home","328":"admin","571":"settings","821":"inspection"}[chunkId] || chunkId) + "." + {"0":"779d37ee","177":"c6652923","249":"fc51b1bb","328":"4f7c96f7","571":"15f69a78","821":"a954603b"}[chunkId] + ".css";
};